/**
 * Nom de l'application affiché dans l'interface et les communications.
 */
export const APP_NAME = 'Les Nouveaux Compagnons';
